export enum SaveIndicatorState {
  None = 0,
  InProgress = 1,
  Saved = 2
}
